import { toastState } from "@/atoms/system/toast-state";
import { GLOBAL_ERROR } from "@/common/constant/global-error";
import { userService } from "@/services/user-service";
import { GradeDto } from "@/types/dto/grade-dto";
import { UserDto } from "@/types/dto/user-dto";
import { Breadcrumb, Button } from "flowbite-react";
import { useSetRecoilState } from "recoil";
import { ButtonColor } from "../../common/enum/button-color";
import { H4 } from "../typography/H4";

interface Props {
  user: UserDto;
  selectedGrade: GradeDto;
  getUser: () => void;
  openHistoryModal: () => void;
  partnerInfo: {
    partnerName: string;
    businessName: string;
    email: string;
    phone: string;
  };
}

export const PartnerDetailHeader: React.FC<Props> = ({
  user,
  selectedGrade,
  getUser,
  openHistoryModal,
  partnerInfo,
}) => {
  const setToast = useSetRecoilState(toastState);
  const historyDisabled = false;
  const updateDisabled =
    user.grade.id === selectedGrade.id &&
    partnerInfo.partnerName === user.name &&
    partnerInfo.businessName === user.businessName &&
    partnerInfo.email === user.email &&
    partnerInfo.phone === user.phone;

  const onClickButton = async () => {
    try {
      const response = await userService.updatePartnerAsync(user.id, {
        gradeId: selectedGrade.id,
        name: partnerInfo.partnerName,
        businessName: partnerInfo.businessName,
        email: partnerInfo.email,
        phone: partnerInfo.phone,
      });
      if (!response.ok) {
        alert(GLOBAL_ERROR);
        return;
      }
      setToast({
        show: true,
        messages: ["변경 사항을 저장했습니다."],
      });
      getUser();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="flex flex-col">
      <Breadcrumb className="pb-0">
        <Breadcrumb.Item>파트너 관리</Breadcrumb.Item>
        <Breadcrumb.Item>파트너 관리</Breadcrumb.Item>
        <Breadcrumb.Item>파트너 상세 정보</Breadcrumb.Item>
      </Breadcrumb>
      <div className="flex items-center justify-between">
        <div className="mt-[14px] mb-[16px]">
          <H4>파트너 상세 정보</H4>
        </div>
        <div className="flex gap-[16px]">
          <Button
            disabled={historyDisabled}
            color={historyDisabled ? "" : ButtonColor.TRANSPARENT_OUTLINE}
            onClick={openHistoryModal}
          >
            수정 이력
          </Button>
          <Button
            disabled={updateDisabled}
            color={updateDisabled ? "" : ButtonColor.PRIMARY}
            onClick={onClickButton}
          >
            정보 저장
          </Button>
        </div>
      </div>
    </div>
  );
};
